import { render } from "./PartMain.vue?vue&type=template&id=e55c7d08"
import script from "./PartMain.vue?vue&type=script&lang=js"
export * from "./PartMain.vue?vue&type=script&lang=js"

import "./PartMain.vue?vue&type=style&index=0&id=e55c7d08&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__